<template>
  <div
    class="work-schedule-skeleton"
    :class="isMobile ? 'work-schedule-skeleton--mobile' : 'work-schedule-skeleton--desktop'"
  >
    <v-skeleton-loader type="text@14" />
  </div>
</template>

<script lang="ts" setup>
import useIsMobile from 'src/composables/useIsMobile'

const isMobile = useIsMobile()
</script>

<style lang="scss">
@import 'src/styles/variables';

.work-schedule-skeleton {
  .v-skeleton-loader {
    display: flex;
    flex-wrap: wrap;
    min-width: 238px;

    &__text {
      flex: 0 1 41%;
      height: 20px;
      margin-bottom: 12px;
      border-radius: $border-radius-md;

      &:nth-last-child(-n+2) {
        margin-bottom: 0;
      }
    }
  }

  &--mobile .v-skeleton-loader__text:nth-child(odd) {
    margin-right: 11%;
  }

  &--desktop .v-skeleton-loader__text:nth-child(odd) {
    margin-right: 15%;
  }
}
</style>
